import React, { useState, useEffect } from 'react';
import Accion from './Accion';
import { FaTimes } from 'react-icons/fa';

const Seccion = ({ seccion, paqueteId, quitarAccion, quitarSeccion, costoUbicacion, areaIntervenir, actualizarCosto }) => {
    const [totalSeccion, setTotalSeccion] = useState(0);

    useEffect(() => {
        const total = seccion.acciones.reduce((acumulador, accion) => {
            return acumulador + (accion.montoTotal || 0);
        }, 0);

        setTotalSeccion(total.toFixed(2)); 
    }, [seccion.acciones, areaIntervenir, costoUbicacion]);

    return (
        <div className="bg-white shadow-sm border border-blue-200 p-2">
            <div className="flex items-center justify-between">
                <div className="flex items-center">
                    <button
                        className="p-1 hover:bg-red-300 rounded-full text-red-600 hover:text-red-800 focus:outline-none"
                        onClick={(e) => quitarSeccion(e, paqueteId, seccion.id)}
                    >
                        <FaTimes size={16} />
                    </button>
                    <h3 className="text-md font-semibold text-blue-800 ml-2">{seccion.seccion}</h3>
                </div>
                <div>
                    <span className="text-red-600 font-semibold">{totalSeccion}</span>
                </div>
            </div>

            <div className="space-y-1 px-2">
                {seccion.acciones.map((accion) => (
                    <Accion
                        key={accion.id}
                        accion={accion}
                        paqueteId={paqueteId}
                        seccionId={seccion.id}
                        quitarAccion={quitarAccion}
                        costoUbicacion={costoUbicacion}
                        areaIntervenir={areaIntervenir}
                        actualizarCosto={actualizarCosto}
                    />
                ))}
            </div>
        </div>
    );
};

export default Seccion;
